import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-interact-comment" }
const _hoisted_2 = { class: "user-interact-amount" }
const _hoisted_3 = { class: "user-interact-dialog-content" }
const _hoisted_4 = { class: "position-relative" }
const _hoisted_5 = { class: "user-interact-dialog-picture" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "user-interact-dialog-title-wrapper" }
const _hoisted_8 = { class: "h4 user-interact-dialog-title" }
const _hoisted_9 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any) {
  const _component_comment = _resolveComponent("comment")!
  const _component_comment_full = _resolveComponent("comment-full")!
  const _component_user_comment_list = _resolveComponent("user-comment-list")!
  const _component_user_comment_form = _resolveComponent("user-comment-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.analytics.commentsCount ? _ctx.analytics.commentsCount : ''), 1),
    _createElementVNode("button", {
      class: "btn btn-icon user-interact-comment-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = !_ctx.dialogVisible))
    }, [
      _createVNode(_component_comment),
      _createVNode(_component_comment_full)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogVisible = $event)),
      width: _ctx.popUpSize + 'px',
      "custom-class": "user-interact-dialog",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("picture", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.newsImage,
                class: "img-fluid user-interact-dialog-image",
                alt: _ctx.newsTitle
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.newsTitle), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_9, _hoisted_11, 512), [
                  [_vShow, _ctx.isLoading]
                ])
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_user_comment_list, {
                  "all-comments": _ctx.allComments,
                  "liked-users-uri": _ctx.likedUsersUri,
                  "like-action": _ctx.likeAction,
                  "analytics-uri": _ctx.analyticsUri,
                  user: _ctx.user,
                  onAddSubComment: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addSubComment($event))),
                  onEditComment: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editComment($event))),
                  onDeleteComment: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteComment($event)))
                }, null, 8, ["all-comments", "liked-users-uri", "like-action", "analytics-uri", "user"]), [
                  [_vShow, _ctx.firstLoad]
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_user_comment_form, {
          "form-options": _ctx.formOptions,
          onUpdateList: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateList($event))),
          onResetForm: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetForm()))
        }, null, 8, ["form-options"])
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ]))
}